var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"input-file-release button__make-up ui-button ui-corner-all ui-widget",class:{'input-file-release--small': _vm.type === 'small'}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._v(" "),_c('input',{ref:"input",attrs:{"type":"file","multiple":_vm.multiple},on:{"change":_vm.change,"click":_vm.clean}})])
}
var staticRenderFns = []

export { render, staticRenderFns }